import { RoleType } from '../../models/Role'
import { type CustomerSeats } from '../../store/plan/plan'
import { seatTypeLabels } from './roleChangeSeatImpact'

export type RequestedGroupKey = 'advisor' | 'assistant'

export interface RequestedSeatGroupDefinition {
  key: RequestedGroupKey
  label: string
  seatType: RoleType
}

export const REQUESTED_SEAT_GROUPS: RequestedSeatGroupDefinition[] = [
  { key: 'advisor', label: `${seatTypeLabels[RoleType.SEAT]} seat`, seatType: RoleType.SEAT },
  { key: 'assistant', label: `${seatTypeLabels[RoleType.SIDECAR]} seat`, seatType: RoleType.SIDECAR },
]

export const freeSeatsFor = (seatType: RoleType, seats?: CustomerSeats): number | undefined =>
  seats ? (seatType === RoleType.SIDECAR ? seats.sidecar.available : seats.general.available) : undefined
